import Q from "./module/q";
import { everyTimeDoAction } from "./utils/index";
import { sendLog, setTrpcConfig} from "./module/send";
import handleData from "./module/handleData";
import Store from "./module/store";

/**
 * CLSLogger
 */
class CLSLogger extends Object {
  constructor(config) {
    super(config);

    this.config = Object.assign({
      name: '',
      uid: '',
      env: 'formal',
      level: 'INFO',
      waitTime: 3000,
      biz: 'YZ',
      version: '0.0.1',
      page: '',
      platform: '',
    }, config || {});

    this.q = new Q();

    this.store = new Store(this.config.name);

    this.sendLog = sendLog.bind(this);

    const baseUrl = this.config.env === 'test' ? 'https://yztest.sparta.html5.qq.com' : 'https://yz.html5.qq.com';

    setTrpcConfig({
      serverUrl: `${baseUrl}/fcgi`,
      version: this.config.version || '0.0.1',
      withCredentials: true,
    }, this);

    everyTimeDoAction(() => {
      this.sendLog(this.q.get());
      this.q.clean();
    }, this.config.waitTime);

    // 处理异常未发送的缓存数据
    const cacheData = this.store.get();

    if (Object.prototype.toString.call(cacheData) === '[object Array]' && cacheData.length) {
      this.q.add(cacheData);
      this.commit();
      this.store.clean();
    }
  }

  setConfig(config) {
    Object.assign(this.config, config);
  }

  setUserId(id) {
    if (typeof id !== 'undefined') {
      this.setConfig({
        uid: `${id}`
      });
    }
  }

  /**
   * uplog 添加上报数据至消息队列
   * @param {String} type 枚举值 FATAL/ERROR/WARN/INFO/DEBUG，可缺省
   * @param {Object} data 上报数据，仅支持对象类型
   * @param {Object} config 配置项，可覆盖默认配置
   */
  uplog(type, data, config) {
    if (!type && !data && !config) {
      return;
    }

    if (typeof type === 'object' || 
    ['FATAL', 'ERROR', 'WARN', 'INFO', 'DEBUG'].indexOf(type) === -1) {
      config = data;
      data = type;
      type = 'INFO';
    }

    const localConfig = {};
    Object.assign(localConfig, this.config, config || {});
    // 处理完成数据后入队
    this.q.add(handleData(type, data, localConfig));
  }

  // 用法同 uplog，实时上报
  uplogNow(type, data, config) {
    if (!type && !data && !config) {
      return;
    }

    if (typeof type === 'object' || 
    ['FATAL', 'ERROR', 'WARN', 'INFO', 'DEBUG'].indexOf(type) === -1) {
      config = data;
      data = type;
      type = 'INFO';
    }

    const localConfig = {};
    Object.assign(localConfig, this.config, config || {});
    this.sendLog([handleData(type, data, localConfig)]);
  }

  commit() {
    this.sendLog(this.q.get());
    this.q.clean();
  }
}

window.CLSLogger = CLSLogger;

export default CLSLogger;
